export enum AuthUserEvent {
  USER_UNAUTHORIZED = 'AuthUserEvent:USER_UNAUTHORIZED',
  USER_CHANGED = 'AuthUserEvent:user_changed',
  SESSION_MISMATCH = 'AuthUserEvent:SESSION_MISMATCH'
}
